export const colors = {
  darkBlue: '#1D192B',
  lightGrey: '#F1F2F4',
  dullBlue: '#5055AD',
  textLightGrey: '#938F99',
  textDarkGrey: '#605D62',
  navyBlue: '#2B2F86',
  lightPurple: '#6750A4',
  dullWhitePurple: '#8388E4',
  chrysomela: '#3A344E',
  skyBlue: '#0098E3',
  lightGreen: '#2AB679',
  brightGreen: '#4AC14F',
  dullLightGreen: '#6FE375',
  yellow: '#FFE250',
  salmon: '#FF887E',
  radicalRed: '#FF5648',
  red: '#FF1C1C',
  lightBlack: '#505050',
  borderGrey: '#C9C5CA',
  lightCyan: '#F4F9FF',
  darkPurple: '#5055AD',
  iconGrey: '#939393',
  softPurple: '#E7E0EC',
  lightBlack0: '#1B1B1B',
  passwordGrey: '#787579',
  backbtnGrey: '#8B8B8B',
  tabBottomGrey: '#EADDFF'
};
